export const getLocationByLesionsObservation = function ( finding, locationMap, multiple = false) {
    let _rtnarr = []
    // console.log('finding', finding)
    for(const lesion of finding.lesions) {
      const observation = lesion.observation
      // console.log('observation', lesion.observation)
      // Observation ex: "Location at distal terminal ileum, Distance 6cm. Description: active bleeding."
      const matchLocation = observation.match(/Location at ([^,|\.]+)/)
      // console.log('matchLocation', matchLocation)
      if (!matchLocation) return null
      let rtnKey = '0'
      const compareStr = matchLocation[1].replace('distal ', '').toLowerCase()
      // console.log('finding.name', finding.name)
      if(finding.name.match(/hemorrhoid/i)) {
        // 例外處理hemorrhoid 固定為 13
        rtnKey = '13'
        _rtnarr.push(rtnKey)
      } else {
        Object.keys(locationMap).find((v) => {
          if (compareStr.match(locationMap[v])) {
            rtnKey = v
            _rtnarr.push(rtnKey)
          }
        })
      }
    }
    if (multiple) {
      return _rtnarr
    }else {
      return _rtnarr.length > 0 ?_rtnarr[0]: '0'
    }
  }